import {Col, Modal, ModalBody, ModalHeader, ModalTitle, Row} from 'react-bootstrap'
import React, {FC, useEffect} from 'react'
import {ErrorMessage, Field, Form, Formik} from 'formik'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import * as Yup from 'yup'
import {Input} from '../../../../../../_metronic/partials/controls'
import {
  confirmTransferByBookingId,
  updateConfirmation,
} from '../../../../../../setup/redux/bookings/actions'
import {getCurrencyDropdown} from '../../../../../../setup/redux/suppliers/actions'
import {RootState} from '../../../../../../setup'
import {HotelAdvancePaymentsTable} from '../../../components/HotelAdvancePaymentsTable'

interface confirmHotel {
  name: string
  confirmation_no: string
  service: string
  id: number
  show: boolean
  hide: any
  hotel_net_amount?: number
  hotel_net_currency?: string
  hotel_due_date?: string
}

export const UpdateConfirmationNumber: FC<confirmHotel> = ({
  name,
  confirmation_no,
  service,
  id,
  show,
  hide,
  hotel_net_amount,
  hotel_net_currency,
  hotel_due_date,
}) => {
  const isHotelService = service === 'hotel' || service === 'custom_hotel'
  const dispatch = useDispatch()
  const {currenciesDropdown}: any = useSelector<RootState>(
    (state) => ({currenciesDropdown: state.suppliers.currenciesDropdown}),
    shallowEqual
  )
  useEffect(() => {
    dispatch(getCurrencyDropdown())
  }, [])

  const toDateString = (val?: string | null) => (val ? String(val).substring(0, 10) : '')

  const confirmTransferInit = {
    confirmation_no: confirmation_no,
    hotel_net_amount: hotel_net_amount ?? '',
    hotel_net_currency: hotel_net_currency ?? 'USD',
    hotel_due_date: toDateString(hotel_due_date),
  }

  const confirmTransferSchema = Yup.object().shape({
    confirmation_no: Yup.string().required().label('Confirmation number'),
    ...(isHotelService && {
      hotel_net_amount: Yup.number().required().positive().label('Hotel net amount'),
      hotel_net_currency: Yup.string().required().label('Currency'),
      hotel_due_date: Yup.string().optional().label('Due date'),
    }),
  })
  return (
    // @ts-ignore
    <Modal show={show} centered={true} size={'md'} onHide={hide}>
      <ModalHeader closeButton>
        <ModalTitle>Update Confirmation - {name}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Formik
          enableReinitialize={true}
          initialValues={confirmTransferInit}
          validationSchema={confirmTransferSchema}
          onSubmit={async (values) => {
            const payload: any = {
              service: service,
              id: id,
              confirmation_no: values.confirmation_no,
            }
            if (isHotelService) {
              payload.hotel_net_amount = Number(values.hotel_net_amount)
              payload.hotel_net_currency = values.hotel_net_currency
              if (values.hotel_due_date) payload.hotel_due_date = values.hotel_due_date
            }
            await dispatch(updateConfirmation(payload))
            setTimeout(() => {
              hide()
            }, 100)
          }}
        >
          {({handleSubmit, values}) => (
            <React.Fragment>
              <Form className='form'>
                <Row>
                  <Col md={12}>
                    <div className={'form-group mb-3'}>
                      <label className='form-label'>
                        Confirmation number<span className='text-danger'>*</span>
                      </label>
                      <Field name='confirmation_no' component={Input} />
                      <ErrorMessage
                        name='confirmation_no'
                        component='div'
                        className='text-danger mt-2'
                      />
                    </div>
                  </Col>
                  {isHotelService && (
                    <>
                      <Col md={8}>
                        <div className={'form-group mb-3'}>
                          <label className='form-label'>
                            Amount to pay hotel<span className='text-danger'>*</span>
                          </label>
                          <Field
                            name='hotel_net_amount'
                            type='number'
                            className='form-control'
                            placeholder='0.00'
                          />
                          <ErrorMessage
                            name='hotel_net_amount'
                            component='div'
                            className='text-danger mt-2'
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className={'form-group mb-3'}>
                          <label className='form-label'>
                            Currency<span className='text-danger'>*</span>
                          </label>
                          <Field
                            as='select'
                            name='hotel_net_currency'
                            className='form-control form-select'
                          >
                            {currenciesDropdown.map((c: any) => (
                              <option key={c.name} value={c.name}>
                                {c.name}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name='hotel_net_currency'
                            component='div'
                            className='text-danger mt-2'
                          />
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className={'form-group mb-3'}>
                          <label className='form-label'>
                            Due date <span className='text-muted'>(optional)</span>
                          </label>
                          <Field name='hotel_due_date' type='date' className='form-control' />
                        </div>
                      </Col>
                      <Col md={12} className='mt-2'>
                        <HotelAdvancePaymentsTable
                          hotelBookingId={id}
                          service={service as 'hotel' | 'custom_hotel'}
                          netAmount={Number(values.hotel_net_amount) || 0}
                          netCurrency={values.hotel_net_currency || 'USD'}
                        />
                      </Col>
                    </>
                  )}
                </Row>
                <Row className='mt-2'>
                  <Col md={12} className='text-end'>
                    <button
                      type='button'
                      name='submit'
                      className='btn btn-primary me-2'
                      onClick={() => handleSubmit()}
                    >
                      Update Now
                    </button>
                  </Col>
                </Row>
              </Form>
            </React.Fragment>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  )
}
